import TableFixedBottom from './table-fixed-bottom'

export default TableFixedBottom